module.exports = __webpack_public_path__ + "static/media/youtube_logo_xs.ff90121e.png";


//////////////////
// WEBPACK FOOTER
// ./src/Application/scenes/Site/Body/scenes/Portfolio/Posts/Post/IconType/img/youtube_logo_xs.png
// module id = 485
// module chunks = 0